module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("<div class=\"prop-header\"><span class=\"prop-label\"></span></div>\r\n<div class=\"row\">\r\n    <div class=\"col-md-12 subsection nopadding-r\">\r\n        <label class=\"prop-sublabel label-65\">Value</label> \r\n        <div>\r\n            <select name=\"dataValue\" id=\"dataValue\">\r\n                <option value=\"none\" datatype=\"NVARCHAR(400)\">None</option>\r\n            </select>\r\n        </div>\r\n    </div>\r\n</div>\r\n<div class=\"row\">\r\n    <div class=\"col-md-12 subsection nopadding-r\">\r\n        <label class=\"prop-sublabel label-65\">&nbsp;</label> \r\n        <div style=\"display: inline-flex;\">\r\n            <select name=\"dataValueSecondary\" id=\"dataValueSecondary\">\r\n                <option value=\"none\" datatype=\"NVARCHAR(400)\">None</option>\r\n            </select>\r\n            <div class=\"nopadding button-opener\">\r\n                <button name=\"valueFormula\" id=\"valueFormula\" class=\"btn btn-default hvr-glow button-selector\">...</button>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>")
  }
  return __output;

}